import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import English translations
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enPages from './locales/en/pages.json';
import enAuth from './locales/en/auth.json';
import enDashboard from './locales/en/dashboard.json';
import enProducer from './locales/en/producer.json';

// Import French translations
import frCommon from './locales/fr/common.json';
import frNavigation from './locales/fr/navigation.json';
import frPages from './locales/fr/pages.json';
import frAuth from './locales/fr/auth.json';
import frDashboard from './locales/fr/dashboard.json';
import frProducer from './locales/fr/producer.json';

// Import Lingala translations
import lnCommon from './locales/ln/common.json';
import lnNavigation from './locales/ln/navigation.json';
import lnPages from './locales/ln/pages.json';
import lnAuth from './locales/ln/auth.json';
import lnDashboard from './locales/ln/dashboard.json';

// Import Swahili translations
import swCommon from './locales/sw/common.json';
import swNavigation from './locales/sw/navigation.json';
import swPages from './locales/sw/pages.json';
import swAuth from './locales/sw/auth.json';
import swDashboard from './locales/sw/dashboard.json';

export const supportedLanguages = ['fr', 'en', 'ln', 'sw'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const languageNames: Record<SupportedLanguage, string> = {
  fr: 'Français',
  en: 'English',
  ln: 'Lingala',
  sw: 'Kiswahili'
};

export const languageFlags: Record<SupportedLanguage, string> = {
  fr: '🇫🇷',
  en: '🇬🇧',
  ln: '🇨🇩',
  sw: '🇹🇿'
};

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    pages: enPages,
    auth: enAuth,
    dashboard: enDashboard,
    producer: enProducer
  },
  fr: {
    common: frCommon,
    navigation: frNavigation,
    pages: frPages,
    auth: frAuth,
    dashboard: frDashboard,
    producer: frProducer
  },
  ln: {
    common: lnCommon,
    navigation: lnNavigation,
    pages: lnPages,
    auth: lnAuth,
    dashboard: lnDashboard
  },
  sw: {
    common: swCommon,
    navigation: swNavigation,
    pages: swPages,
    auth: swAuth,
    dashboard: swDashboard
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'pages', 'auth', 'dashboard', 'producer'],
    
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'agrinabiso-language',
      caches: ['localStorage']
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    react: {
      useSuspense: false // Avoid loading flash
    }
  });

export default i18n;
